import Vue from 'vue'
import moment from 'moment'
import axios from 'axios'
import 'moment/src/locale/es'
import './plugins/globalComponents'
import './plugins/sentry'
import App from './App.vue'
import router from './router'
import store from './store/'
import './registerServiceWorker'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import vuetify from './plugins/vuetify'
import { cleanJSON } from '@/utilidades'
import '@mdi/font/css/materialdesignicons.css'
import VueHtmlToPaper from 'vue-html-to-paper'
import fullscreen from 'vue-fullscreen'
//import titlebar from '@wuild/vue-titlebar'
import camposObligatorios from './mixins/camposObligatorios'
moment.locale('es')
Vue.use(fullscreen)
// const VueTitlebar = require('@wuild/vue-titlebar')
// Vue.use(VueTitlebar)

const options = {
  name: '_blank',
  specs: [scrollbars, fullscreen],
}

Vue.use(VueHtmlToPaper, options)

axios.interceptors.request.use(
  (config) => {
    if (['post', 'put', 'patch'].includes(config.method)) {
      config.data = cleanJSON(config.data)
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

router.beforeEach((to, from, next) => {
  if (['/', '/ru'].includes(to.path)) next('/bienvenido')
  else if (
    ['/bienvenido', '/began', '/soporte', '/ayuda', '/login', '/ru/listados', '/cuenta'].includes(to.path)
  )
    next()
  else if (
    (to.path.includes('reportes') ||
      //to.path.includes('consulta') ||
      //to.path.includes('formularioconsul') ||
      to.path.includes('coagroindustrias') ||
      to.path.includes('coagroindustria') ||
      to.path.includes('coacuiculturas') ||
      to.path.includes('coacuicultura') ||
      to.path.includes('copecuarios') ||
      to.path.includes('copecuario') ||
      to.path.includes('cocosechas') ||
      to.path.includes('cocosecha') ||
      to.path.includes('cocultivos') ||
      to.path.includes('cocultivo') ||
      to.path.includes('conexpediente') ||
      //to.path.includes('formularioconexpe') ||
      to.path.includes('coparcelas') ||
      to.path.includes('coparcela') ||
      to.path.includes('copreparaciones') ||
      to.path.includes('copreparacion') ||
      to.path.includes('coagroturismos') ||
      to.path.includes('coagroturismo') ||
      to.path.includes('coartesanias') ||
      to.path.includes('coartesania') ||
      to.path.includes('coapiculturas') ||
      to.path.includes('coapicultura') ||
      to.path.includes('cofincas') ||
      to.path.includes('cofinca')) &&
    store.getters['auth/userCan'](to.path).read
  )
    next()
  else if (
    (/* !to.path.includes('reportes') ||*/
      to.path.startsWith('/ru/productores') ||
      to.path.startsWith('/ru/productor') ||
      to.path.includes('costos') ||
      to.path.includes('costo') ||
      to.path.includes('avicola') ||
      to.path.includes('avicolas') ||
      to.path.includes('agroindustrias') ||
      to.path.includes('agroindustria') ||
      to.path.includes('acuiculturas') ||
      to.path.includes('acuicultura') ||
      to.path.includes('forestales') ||
      to.path.includes('forestal') ||
      to.path.includes('pecuarios') ||
      to.path.includes('pecuario') || 
      to.path.includes('inventario') ||    
      to.path.includes('pesca') ||
      to.path.includes('pescas') ||  
      to.path.includes('embarcacion') ||
      to.path.includes('embarcaciones') ||
      to.path.includes('cosechas') ||
      to.path.includes('cosecha') ||
      to.path.includes('cultivos') ||
      to.path.includes('cultivo') ||
      to.path.includes('empresa') ||
      to.path.includes('crearempresa') ||
      to.path.includes('parcelas') ||
      to.path.includes('parcela') ||
      to.path.includes('preparaciones') ||
      to.path.includes('preparacion') ||
      to.path.includes('agroturismos') ||
      to.path.includes('agroturismo') ||
      to.path.includes('artesanias') ||
      to.path.includes('artesania') ||
      to.path.includes('apiculturas') ||
      to.path.includes('apicultura') ||
      to.path.includes('finca') ||
      to.path.includes('fincas')) &&
    store.getters['auth/userCan'](to.path).edit
  )
    next()
  else {
    store.commit('ui/setSnack', {
      text: 'No tiene permiso para acceder a este módulo.',
      color: 'error',
    })

    next(false)
  }
})

Vue.config.productionTip = false

// Mixin global
Vue.mixin(camposObligatorios)


new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app')
